export const firebaseConfig = {
  apiKey: 'AIzaSyC0Efb34ZdGDnlA4DS7t4HegGfxX3uH2o0',
  authDomain: 'llm-macro-tracker-app.firebaseapp.com',
  projectId: 'llm-macro-tracker-app',
  storageBucket: 'llm-macro-tracker-app.appspot.com',
  messagingSenderId: '939644337857',
  appId: '1:939644337857:web:980ec1678a811966f15e40',
  measurementId: 'G-ZV6GW1XRS6',
};
